import { render } from 'preact';
import { App } from './App';

render(<App />, document.getElementById('app')!);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW failures are non-fatal — app works without offline shell. */
    });
  });
}
